<script>
import LegoBtn from "@/components/Lego/LegoBtn.vue";

export default {
  components: {
    LegoBtn,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hasUnreadMessages: false,
    };
  },
  computed: {
    cardId() {
      return this.$route.params.cardId;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
  },
  mounted() {
    this.fetchHasUnReadMessages();
  },
  methods: {
    async fetchHasUnReadMessages() {
      try {
        const res = await this.$store.dispatch("hl_get", {
          path: `Lego/chat/hasUnreadByCard/${this.cardId}/${this.userLoggedIn.id}`,
        });
        // console.log("hasUnreadMessages", res);
        if (res) this.hasUnreadMessages = res;
      } catch (error) {
        console.error("Error al obtener mensajes:", error);
      }
    },
  },
};
</script>

<template>
  <router-link :to="{
    name: 'LegoCardProcess',
    params: { process: 'Chat', cardId: card.id },
  }">
    <LegoBtn class="has-unread-messages">
      <span>
        <i class="far fa-comments"></i>
      </span>
      Chat
      <span v-if="hasUnreadMessages" class="notification-dot"></span>
    </LegoBtn>
  </router-link>
</template>

<style scoped>
@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
  }
}

.has-unread-messages {
  position: relative;
}

.notification-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #ff7857;
  border-radius: 50%;
  animation: blink 1s infinite;
}
</style>
